import { render, staticRenderFns } from "./More.vue?vue&type=template&id=0cfed216&scoped=true&lang=pug&"
import script from "./More.vue?vue&type=script&lang=js&"
export * from "./More.vue?vue&type=script&lang=js&"
import style0 from "./More.vue?vue&type=style&index=0&id=0cfed216&prod&lang=less&scoped=true&"
import style1 from "./More.vue?vue&type=style&index=1&id=0cfed216&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfed216",
  null
  
)

export default component.exports